<template>
    <div>

        <app-bar :menu="appMenu"
                 @addToMenu="_addToMenu"
        >
            <template v-slot:action>
                <v-btn icon @click="getGeo">
                    <v-icon>mdi-target-variant</v-icon>
                </v-btn>
            </template>

        </app-bar>

        <v-dialog
                v-model="promptGeolocate"
                max-width="300"
                persistent
        >
            <v-card>
                <v-card-title class="headline">
                    <v-icon>mdi-map-marker-question-outline</v-icon>
                    Geolocalizzazione
                </v-card-title>

                <v-card-text>
                    Vuoi abilitare la geolocalizzazione per migliorare i risultati?
                </v-card-text>

                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn text @click="disableGeo">
                        Nega
                    </v-btn>
                    <v-btn text color="deep-purple darken-1" @click="getGeo">
                        <strong>Consenti</strong>
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-text-field
                class="searchbar sticky"
                v-model="search"
                :loading="isLoading"
                clearable
                flat
                solo-inverted
                prepend-inner-icon="mdi-map-marker"
                append-icon="mdi-magnify-plus-outline"
                placeholder="Cerca un Club per nome, Provincia o Membro"
                @click:clear="items = []"
                @click:append="searchClub(search)"
        ></v-text-field>

        <v-expand-transition>
            <v-card tile v-show="showResult" class="sticky">

                <v-virtual-scroll
                        :items="items"
                        max-height="400"
                        item-height="70"
                        bench="3"
                >

                    <template v-slot:default="{ item }">


                        <v-list-item two-line
                                     @click="openDetails(item.container_id)">
                            <v-list-item-avatar class="elevation-2">
                                <v-img :alt="item.asd_name" :src="item.logo"></v-img>
                            </v-list-item-avatar>
                            <v-list-item-content>
                                <v-list-item-title>{{item.asd_name}}</v-list-item-title>
                                <v-list-item-subtitle>{{item.province}}</v-list-item-subtitle>
                            </v-list-item-content>
                        </v-list-item>

                    </template>
                </v-virtual-scroll>

            </v-card>
        </v-expand-transition>

        <div v-if="clubs.length > 0" v-for="club_group in clubs">
            <clubSheet @openDetails="openDetails" :clubs="club_group" :logoSize="110" :coverHeight="100"></clubSheet>
        </div>

        <div class="mt-5 text-center" v-if="showLoading">
            <v-btn v-intersect="{
                                    handler: loadMore,
                                    options: {
                                       rootMargin:'0px 0px -100px 0px',
                                       threshold: [0.75]
                                    }
                                  }"
                   fab small loading></v-btn>
        </div>

    </div>
</template>

<script>
    import axios from 'axios';
    import {mapMutations, mapActions, mapGetters} from 'vuex'
    import clubSheet from '../components/clubSheet'

    export default {
        name: 'Club',
        components: {
            clubSheet
        },
        data() {
            return {
                isLoading: false,
                search: '',
                items: [],
                appMenu: [
                    {text: 'Aggiungi al Menù', icon: 'mdi-pin', action: 'addToMenu'},
                ],

                limit: 3,
                offset: 0,
                distance: 1500,
                coords: false,

                showLoading: false,
                clubs: [],
                loadingMoreData: false
            }
        },

        mounted() {
            this.setLoading(true);
            setTimeout(() => {
                this.getClubList();
            }, 100);
            //this.getGeo();
        },

        methods: {
            ...mapMutations([
                'setLoading',
                'setFlash',
                'setGeolocate'
            ]),
            ...mapActions([
                '_addToMenu'
            ]),
            debounce(val) {
                clearTimeout(this._searchTimerId);
                this._searchTimerId = setTimeout(() => {
                    this.searchClub(val);
                }, 500);
            },

            requestPermissions() {
                //TODO: boh non so come fare....
                //console.log(navigator.permissions.query({name: 'geolocation'}));
                navigator.geolocation.getCurrentPosition(() => {
                    console.log
                }, () => {
                    console.log
                });
            },

            getGeo() {

                if (navigator.geolocation) {
                    let _this = this;
                    navigator.geolocation.getCurrentPosition(handle_geolocation_query, handle_errors, {
                        enableHighAccuracy: true,
                        timeout: 5000,
                        maximumAge: 0
                    });

                    function handle_errors(error) {
                        console.log(error);
                        switch (error.code) {
                            case error.PERMISSION_DENIED:
                                _this.setFlash("Hai disabilitato la geolocalizzazione!");
                                _this.setGeolocate(false);
                                _this.requestPermissions();
                                break;

                            case error.POSITION_UNAVAILABLE:
                                _this.setFlash("Al momento non riusciamo a trovare la tua posizione!");
                                break;

                            case error.TIMEOUT:
                                _this.setFlash("Errore! Riprova.");
                                break;

                            default:
                                _this.setFlash("Errore sconosciuto!");
                                break;
                        }
                    }

                    function handle_geolocation_query(pos) {
                        //_this.setFlash("Localizzazione per la ricerca abilitata!");
                        _this.setGeolocate(true);
                        _this.clubs = [];
                        _this.coords = {'lat': pos.coords['latitude'], 'lng': pos.coords['longitude']};
                        //console.log(_this.coords)
                    }

                } else {
                    console.warn('Geolocation is not supported by this browser.');
                }
            },

            disableGeo() {
                this.setGeolocate(false);
            },

            async getClubList() {
                await axios
                    .post(this.$store.state.ROOT_API + '/club/list', {
                        limit: this.limit,
                        offset: this.offset,
                        distance: this.distance,
                        coords: this.coords
                    }, {
                        headers: {
                            'Authorization': 'Bearer ' + this.$store.getters.getToken
                        }
                    })
                    .then(resp => {
                        this.setLoading(false);
                        this.showLoading = resp.data.list.length > 0;
                        this.clubs.push(resp.data.list);
                        //console.log(resp.data.list);
                    })
                    .catch((error) => {
                        console.error(error)
                    })
            },

            searchClub(q) {
                if (q.length > 2) {
                    this.isLoading = true;
                    axios
                        .post(this.$store.state.ROOT_API + '/club/search', {term: q}, {
                            headers: {
                                'Authorization': 'Bearer ' + this.$store.getters.getToken
                            }
                        })
                        .then(resp => {
                            this.items = resp.data.clubs;
                        })
                        .catch((error) => {
                            console.error(error)
                        })
                        .finally(() => (this.isLoading = false))
                }
            },

            loadMore(entries, observer, isIntersecting) {
                this.offset = this.clubs.length * this.limit;
                this.loadingMoreData = isIntersecting;
                if (isIntersecting && this.loadingMoreData) {
                    this.getClubList();
                    this.loadingMoreData = false;
                }

            },

            openDetails(id) {
                this.$router.push({
                    name: 'club',
                    params: {club_id: id, back_to: this.$route}
                })
            },
        },

        watch: {
            search(val, oldVal) {
                if (val === oldVal) {
                    return;
                }
                if (val.length === 0) {
                    this.items = [];
                }
                this.debounce(val);
            },
        },

        computed: {
            ...mapGetters([
                'getGeolocate'
            ]),
            showResult() {
                return this.items.length > 0;
            },
            promptGeolocate() {
                if (this.getGeolocate) {
                    return false;
                }
                return !!navigator.geolocation && this.getGeolocate
            }
        }

    }
</script>

<style scoped>
    .map {
        width: 100%;
        background-color: #333;
        margin: 48px 0 auto 0;
        padding: 0;
        min-height: 80vh;
        z-index: 1;
    }

    .searchbar {
        height: 48px;
        background: #5E35B1;
        border-radius: 0 !important;
        width: 100vw;
        margin: 0;

    }

    .searchbar >>> .v-icon, .searchbar >>> input, .searchbar >>> input::placeholder {
        color: white !important;
    }

    .sticky {
        position: -webkit-sticky;
        position: sticky;
        top: 56px;
        z-index: 1;
    }

    .searchbar > div.v-input__control > div.v-input__slot {
        padding: 10px 5px !important;
    }

    .searchresult {
        width: 100vw;
    }
</style>